module.exports = __webpack_public_path__ + "static/media/scrap-car-pickup-beenleigh.e0681ec7.png";